import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { throttle } from "../../../utils/throttle";
export const ResizeSystemsHandle = ({ initialWidth, onSetWidthCb, onSetIsResizingCb, handlerTop = 0, }) => {
    const throttledSetWidthCb = throttle(onSetWidthCb, 100);
    const prevSpace = 56;
    const handlerSize = 24;
    const minWidth = 250 - prevSpace;
    const [isResizing, setIsResizing] = useState(false);
    const [width, setWidth] = useState(initialWidth + prevSpace - handlerSize);
    // useEffect(() => {
    //   setWidth(initialWidth);
    //   onSetWidthCb(initialWidth);
    // }, [initialWidth]);
    useEffect(() => {
        onSetIsResizingCb(isResizing);
    }, [isResizing]);
    useEffect(() => {
        throttledSetWidthCb(width - handlerSize);
    }, [width]);
    // const [isDefaultWidth, setIsDefaultWidth] = useState(true); // is this needed?
    const handleMouseDown = (e) => {
        // setWidth(width);
        setIsResizing(true); // Enable resizing
    };
    const getNewWidth = (mousePos) => {
        const _minWidth = minWidth + prevSpace;
        const maxWidth = window.innerWidth - handlerSize;
        let _mousePos = mousePos;
        if (mousePos > maxWidth) {
            _mousePos = maxWidth;
        }
        if (_mousePos < _minWidth) {
            _mousePos = _minWidth;
        }
        return _mousePos;
    };
    // Handle mouse move during the resizing process
    const handleMouseMove = (e) => {
        const newX = "clientX" in e ? e.clientX : e.changedTouches[0].clientX;
        if (isResizing) {
            const newWidthTmp = getNewWidth(newX); // Calculate new
            setWidth(newWidthTmp);
        }
    };
    const handleMouseUp = (e) => {
        if (isResizing) {
            const newX = "clientX" in e ? e.clientX : e.changedTouches[0].clientX;
            const newWidth = getNewWidth(newX); // Calculate new width based on distance from right edge
            setWidth(newWidth); // Update width dynamically
        }
        setIsResizing(false); // Disable resizing
        onSetIsResizingCb(false);
    };
    // Add event listeners for mouse move and mouse up
    useEffect(() => {
        if (isResizing) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
            window.addEventListener("touchmove", handleMouseMove);
            window.addEventListener("touchend", handleMouseUp);
        }
        else {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("touchmove", handleMouseMove);
            window.removeEventListener("touchend", handleMouseUp);
        }
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("touchmove", handleMouseMove);
            window.removeEventListener("touchend", handleMouseUp);
        };
    }, [isResizing]);
    const handleResize = (_width) => {
        const newWidth = getNewWidth(_width);
        setWidth(newWidth);
    };
    useEffect(() => {
        const _handleResize = () => {
            handleResize(width);
        };
        window.addEventListener("resize", _handleResize);
        return () => {
            window.removeEventListener("resize", _handleResize);
        };
    }, [width]);
    const theme = useTheme();
    return (_jsx(Box, Object.assign({ onMouseDown: handleMouseDown, onTouchStart: handleMouseDown, sx: {
            width: `${handlerSize}px`,
            // backgroundColor: "#f5f5f5",
            position: "fixed",
            left: `${width}px`,
            // left: 0, // Position the handle on the left-most edge of the component
            top: `${handlerTop + 10}px`,
            cursor: "col-resize",
            zIndex: 2, // Ensure the handle is above the other content
            // display: "flex",
            // alignItems: "center",
        } }, { children: _jsx(HorizontalRuleIcon, { className: "system-drag-handle", 
            // fontSize="small"
            sx: {
                transform: "rotate(90deg)",
                color: "#ffffff",
                // mr: -1,
                cursor: "col-resize",
                "&:hover, &:active": {
                    color: theme.palette.info.light,
                },
            } }) })));
};
